module.exports = __webpack_public_path__ + "img/default-image.a2764820.png";